import React, { useRef, useState } from "react";

import {
  Box,
  Divider,
  Icon,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";

import { PageTitle } from "components/PageTitle";
import { OrderReadQuery } from "components/gql/queris/GetOrderInfo";
import { GetCInfo } from "contexts/CompanyContext";
import { GetData } from "contexts/DataContext";

import { StarOutline, SwapVert } from "@mui/icons-material";
import { Pincode } from "@prkhch/react-pincode";
import { GetCreditsQuery } from "components/gql/queris/GetCredits";
import {
  findInArray,
  formatPhone,
  getOrderDate,
  isIdentical,
  isObjectEmpty,
  saveMap,
  translateOrderType,
} from "data/functions";
import { ProfileTable } from "pages/orders/info/ProfileTable";
// import { useAuth } from "react-oidc-context";
import { useLocation, useParams } from "react-router-dom";
import { OrderParams, ParamRow } from "./OrderParams";
import { PayButton } from "./PayButton";

export default function OrderProfile() {
  let location = useLocation();
  const { dataObj } = GetData();
  const { cInfo } = GetCInfo();
  // const auth = useAuth();

  const orderID = location.state?.orderID;
  const clientID = location.state?.clientID;
  const [orderGQL] = OrderReadQuery();
  const [docItem, setDocItem] = useState(
    findInArray(dataObj?.searchDocs, orderID, "orderID") || {}
  );
  const [phoneCheck, setPhoneCheck] = useState(false);

  React.useEffect(() => {
    let val = findInArray(dataObj?.searchDocs, orderID, "orderID");
    if (val && !isIdentical(docItem, val)) {
      setDocItem(val);
      // alert("TTT");
    }
    // eslint-disable-next-line
  }, [dataObj?.searchDocs]);

  React.useEffect(() => {
    let val = findInArray(dataObj?.searchDocs, orderID, "orderID");
    if (val && !isIdentical(docItem, val)) {
      setDocItem(val);
      // alert("DDD");
    }
    if (!val && orderID && clientID) {
      orderGQL({
        variables: {
          companyUUID: cInfo?.UUID,
          orderId: orderID,
          userID: docItem?.user?.id,
        },
      });
    }
    // eslint-disable-next-line
  }, [cInfo?.UUID, orderID, docItem]);

  React.useEffect(() => {
    if (
      !isObjectEmpty(docItem?.user?.phone) &&
      [...(docItem?.user?.phone ?? [])].find((el) => el?.length >= 5)
    ) {
      setPhoneCheck(false);
      // alert("TTT");
    } else {
      setPhoneCheck(true);
    }
    // eslint-disable-next-line
  }, [docItem]);

  return (
    <React.Fragment>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          height: "100%",
          overflow: "hidden",
          padding: "0.4rem",
          width: "100%",
        }}
      >
        <PageTitle
          title={translateOrderType(docItem.type)}
          title2={getOrderDate(docItem)}
        />
        <Box
          sx={{
            alignSelf: "center",
            margin: "0rem 1rem 0rem 1rem",
            maxWidth: "820px",
            overflow: "auto",
            width: "100%",
          }}
        >
          {!phoneCheck &&
            !isObjectEmpty(docItem?.user?.phone) &&
            [...(docItem?.user?.phone ?? [])].find((el) => el?.length >= 5) && (
              <PhoneCheck docItem={docItem} setPhoneCheck={setPhoneCheck} />
            )}
          {phoneCheck && (
            <React.Fragment>
              {docItem.type === "ЛИД" && (
                <Typography>
                  Вы отправили заявку. Пожалуйста, ожидайте рассмотрения.
                </Typography>
              )}
              <OrderParams department={docItem?.department} docItem={docItem} />
              {/* <br /> */}
              <ProfileTable docItem={docItem} />

              {Number(docItem?.userCredits) > 0 && (
                <ParamRow
                  subTitle={
                    <Box
                      sx={{
                        alignItems: "center",
                        display: "flex",
                        flexDirection: "row",
                      }}
                    >
                      <Typography>{Number(docItem?.userCredits)}</Typography>
                      <StarOutline sx={{ height: "0.96em", width: "0.96em" }} />
                    </Box>
                  }
                  title={"Остаток бонусных баллов"}
                />
              )}
              <br />
              <PayButton docItem={docItem} orderID={orderID} />
              {/* {!isObjectEmpty(department) && <MapBlockOnePoint item={department} />} */}
            </React.Fragment>
          )}
        </Box>
      </Box>
    </React.Fragment>
  );
}

function PhoneCheck(props) {
  const ref = useRef();
  const [numbers, setNumbers] = useState([]);

  React.useEffect(() => {
    let arr = [];
    saveMap(props?.docItem?.user?.phone).forEach((el) => {
      if (el?.length >= 5) {
        let n = formatPhone(el);
        arr = [...arr, n?.slice(-4)];
      }
    });
    setNumbers(arr);
  }, [props?.docItem]);

  const onComplete = ({
    inputValue,
    setErrorMessage,
    setMessage,
  }: ON_COMPLETE_PROPS) => {
    // Request correct password from the server.
    // Example correct password : 0000

    if (saveMap(numbers).find((el) => el === inputValue)) {
      // setMessage(String.fromCodePoint(32));
      props?.setPhoneCheck(true);
      setErrorMessage("");
    } else {
      setErrorMessage("Данные не совпадают!");
      // ref.current.style[".inputBox.svg"].border = "1 px solid red";
      // setErrorMessage("Не!");
    }
  };
  if (numbers.length === 0) {
    return;
  }

  return (
    <Box
      ref={ref}
      sx={{
        ".container": { height: "100%" },
        ".containerBottom": { height: "100%" },
        ".keypadBox": { width: "unset" },
        ".keypadRow": { height: "unset" },
        ".shake": {
          animation: "vibration 0.05s",
        },
        alignContent: "center",
        alignItems: "center",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        paddingTop: "24px",
        width: "100%",
      }}
    >
      <Typography sx={{ padding: "12px 0" }} textAlign={"center"}>
        Введите последние 4 цифры
        <br />
        номера телефона
      </Typography>

      <Pincode
        defaultMessage="&nbsp;"
        // randomKeypad={true}
        length={4}
        onComplete={onComplete}
        style={{
          // "&containerBottom": { height: "100px!important" },
          maxWidth: "400px",
          width: "100%",
        }}
        styleBackgroundColor="transparent"
        styleBackgroundOpacity={1}
        // styleBottomLayout={true}
        styleDeleteButtonColor="red"
        styleErrorMessageColor="red"
        styleHoverColor="#efefef"
        styleInputBoxColor="#efefef"
        styleInputCircleColor="#000000"
        styleMessageColor="#000000"
        styleNumberButtonColor="#efefef"
        styleNumberFontColor="#000000"
        styleResetButtonColor="blue"
      />
    </Box>
  );
}
